type Simple = string | number | null | undefined | boolean

/**
 * Converts an object into a query parameter string. This function supports multiple params of the same name by passing
 * them as an array
 *
 * @param obj - any set of query parameters
 *
 * @returns - constructed & encoded query string for a URL
 */
export function createQueryParams(obj: Record<string, Array<Simple> | Simple>): string {
  let queryParams = '?'

  for (const key of Object.keys(obj)) {
    const value = obj[key]

    if (Array.isArray(value) && value.length) queryParams += `${key}=${encodeURIComponent(value.join(`&${key}=`))}`
    // @ts-ignore - TS is wrong here, you can totally encode null | undefined - it just uses the string for each. So dumb
    else queryParams += `${key}=${encodeURIComponent(value)}`

    queryParams += '&'
  }

  return queryParams
}
